import ConversationReflection from "../model/ConversationReflection";

export default class ConversationReflectionEndedEvent {
    /**
     * @constructor
     * @param {ConversationReflection} conversation 
     */
    constructor(type, conversation) {
        this._type = type;
        this._conversation = conversation;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }
}

ConversationReflectionEndedEvent.PERFORM = 'ConversationReflectionEndedEvent.PERFORM';